import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/images/line.svg'


const _hoisted_1 = { class: "explore-speeds" }
const _hoisted_2 = { class: "explore-speeds-wrap" }
const _hoisted_3 = { class: "explore-mbps" }
const _hoisted_4 = {
  class: "starting",
  style: {"padding-top":"15px"}
}
const _hoisted_5 = { style: {"font-size":"14px","line-height":"1.5"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_Swiper = _resolveComponent("Swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "mb-4" }, "لماذا تختار خدماتنا في أمريكا وكندا؟", -1)),
    _createVNode(_component_Swiper, {
      "slides-per-view": 1,
      "space-between": 24,
      centeredSlides: false,
      preventClicks: true,
      loop: true,
      breakpoints: {
        0: { slidesPerView: 1 },
        768: { slidesPerView: 2 },
        992: { slidesPerView: 3 },
        1440: { slidesPerView: 4 },
        1600: { slidesPerView: 5 },
      },
      modules: _ctx.modules,
      class: "explore-speeds-slide"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.featuresList, (feature, index) => {
          return (_openBlock(), _createBlock(_component_SwiperSlide, { key: index }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _cache[0] || (_cache[0] = _createElementVNode("img", {
                    src: _imports_0,
                    alt: "line"
                  }, null, -1)),
                  _createElementVNode("h2", null, _toDisplayString(feature.title), 1)
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("h6", _hoisted_5, _toDisplayString(feature.desc), 1)
                ])
              ])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }, 8, ["modules"])
  ]))
}